import { render, staticRenderFns } from "./PresetsRaces.vue?vue&type=template&id=290271f8&scoped=true"
import script from "./PresetsRaces.vue?vue&type=script&lang=js"
export * from "./PresetsRaces.vue?vue&type=script&lang=js"
import style0 from "./PresetsRaces.vue?vue&type=style&index=0&id=290271f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290271f8",
  null
  
)

export default component.exports